<template>
  <v-card>
    <v-dialog v-model="service_dialog" max-width="600">
      <v-card>
        <v-toolbar color="grey darken-3" dark elevation="1">
          <v-toolbar-title>
            Створення нової послуги
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-6">
          <v-row>
            <v-col cols="12">
              <v-text-field
                  v-model="new_service_name" hide-details filled
                  color="grey"
                  label="Назва послуги"
                  required :rules="[v => !!v || 'Це поле є обов’язковим']"
                  :class="new_service_name ? '' : 'req-star'"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              depressed
              text
              color="secondary darken-1"
              @click.stop="createOneTimeService"
              class="button-accept"
              v-if="savable"
              :loading="getModalLoading"
          >
            <v-icon left>mdi-content-save</v-icon>
            Зберегти
          </v-btn>
          <v-btn depressed text tile color="grey" @click.stop="service_dialog = false">
            <v-icon left>mdi-close</v-icon>
            Відмінити
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar color="grey darken-3" dark elevation="1">
      <v-toolbar-title>
        {{ title }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              class="grey darken-3"
              icon
              outlined
              :disabled="isNew"
              v-bind="attrs"
              v-on="on"
              :loading="getModalLoading"
              @click="menu = true"
          >
            <v-icon color="secondary">mdi-arrow-down-drop-circle-outline</v-icon>
          </v-btn>
        </template>
        <v-list dense rounded nav>
          <v-list-item link class="px-4" @click.stop="deleteDialog" v-if="savable">
            <v-list-item-icon>
              <v-icon color="error lighten-1">mdi-delete-forever-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="font-weight-medium">Вилучити</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-card-text class="pt-6">
      <v-form v-model="formValid" ref="form">
        <v-row class="dense-wrapper">
          <v-col cols="12" class="pt-0">
            <v-switch
                class="mt-1"
                v-model="all_flats"
                hide-details
                label="Усі абоненти організації"
                color="secondary"/>
          </v-col>
          <v-col cols="12">
            <AddressElementSelect v-model="city_id"
                                  label="Населений пункт" filled
                                  select_type="city"
            />
          </v-col>
          <v-col cols="12">
            <AddressElementSelect :parent_id="city_id" v-model="streets"
                                  label="Вулиця(-ки)" multiple filled
                                  select_type="street" use_parent_id
                                  :disabled="!city_id"
            />
          </v-col>
          <v-col cols="12">
            <AddressElementSelect :parent_id="streets" v-model="buildings"
                                  label="Будинок(-ки)" multiple filled
                                  select_type="building" use_parent_id
                                  :disabled="!streets.length"
            />
          </v-col>
          <v-col cols="12">
            <v-select :items="services_"
                      filled label="Абоненти із цією послугою"
                      hide-details
                      v-model="flats_with_this_service"
                      color="grey"
            />
          </v-col>
          <v-col cols="12">
            <AC_TariffGroup :value="tariff_group_type_id" @autocompleteChange="autocompleteChange"/>
          </v-col>
          <v-col cols="6">
            <v-select :items="buildingTypesSelect" hide-details color="grey" filled
                      v-model="building_type"
                      label="Тип будинку (вид житла)"
            />
          </v-col>
          <v-col cols="6">
            <v-select :items="flatTypesSelect" hide-details color="grey" filled
                      v-model="flat_type"
                      label="Тип абонента (житлові/нежитлові)"
            />
          </v-col>
          <v-col cols="6">
            <v-select :items="divideMethodSelect" hide-details color="grey" filled
                      v-model="divide_method"
                      label="Метод нарахування"
                      required :rules="[v => !!v || 'Це поле є обов’язковим']"
                      :class="divide_method ? '' : 'req-star'"
            />
          </v-col>
          <v-col cols="6">
            <v-select :items="calculateMethodsSelectFiltered" hide-details color="grey" filled
                      v-model="calculate_method"
                      label="Вид розрахунку"
                      required :rules="[v => !!v || 'Це поле є обов’язковим']"
                      :class="calculate_method ? '' : 'req-star'"
            />
          </v-col>
          <v-col cols="12" class="d-flex">
            <v-select :items="services_" filled label="Послуга (для нарахування)"
                      hide-details
                      v-model="service_id"
                      required :rules="[v => !!v || 'Це поле є обов’язковим']"
                      :class="service_id ? '' : 'req-star'"
                      color="grey"
                      class="mr-2"
            />
            <v-btn height="100%" depressed color="secondary" @click.stop="openServiceDialog">
              <v-icon left size="22">mdi-plus</v-icon>
              Створити послугу
            </v-btn>
          </v-col>
          <v-col :cols="calculate_method === 'by_counter' ? 12 : 6"
                 v-if="calculate_method === 'by_counter' || divide_method === 'multiply_volume_by_tariff'">
            <v-select :items="services_"
                      filled label="Послуга (показників)"
                      hide-details
                      v-model="counter_service_id"
                      required :rules="[v => !!v || 'Це поле є обов’язковим']"
                      :class="counter_service_id ? '' : 'req-star'"
                      color="grey"
                      class="mr-2"
            />
          </v-col>
          <v-col cols="6"
                 v-if="divide_method === 'multiply_volume_by_tariff'">
            <v-select :items="filter_by_counter_select"
                      filled label="Відбір по наявності ліч."
                      hide-details
                      v-model="filter_by_counter"
                      required :rules="[v => !!v || 'Це поле є обов’язковим']"
                      :class="filter_by_counter ? '' : 'req-star'"
                      color="grey"
                      class="mr-2"
            />
          </v-col>
          <v-col cols="12" v-if="calculate_method ? calculate_method === 'by_square' : false">
            <AC_FlatIndicatorType :value="indicator_id" @autocompleteChange="flatIndicatorTypeChange"
                                  :class="indicator_id ? '' : 'req-star'" color="grey"/>
          </v-col>
          <v-col cols="6"
                 v-if="divide_method === 'multiply_volume_by_tariff'"
          >
            <v-text-field
                v-model="volume" hide-details v-decimal filled color="grey"
                label="Об’єм"
                required :rules="[v => !!v || 'Це поле є обов’язковим']"
                :class="volume ? '' : 'req-star'"
            />
          </v-col>
          <v-col cols="6"
                 v-if="divide_method === 'divide_volume_tariff'"
          >
            <v-text-field
                v-model="volume" hide-details v-decimal filled color="grey"
                label="Об’єм розподілу"
                required :rules="[v => !!v || 'Це поле є обов’язковим']"
                :class="volume ? '' : 'req-star'"
            />
          </v-col>
          <v-col :cols="divide_method === 'divide_volume_tariff' ? 6 : divide_method === 'multiply_volume_by_tariff' ? 6 : 12">
            <v-text-field
                v-model="tariff" hide-details v-decimal filled color="grey"
                label="Тариф/Сума"
                required :rules="[v => !!v || 'Це поле є обов’язковим']"
                :class="tariff ? '' : 'req-star'"
            />
          </v-col>
          <v-col cols="12">
            <v-textarea
                v-model="comment" filled
                label="Коментар"
                color="grey" hide-details
                auto-grow rows="1" />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn depressed text color="secondary darken-1" @click.stop="createFlatIndicator" :loading="getModalLoading"
             class="button-accept" v-if="savable">
        <v-icon left>mdi-content-save</v-icon>
        Зберегти
      </v-btn>
      <v-btn depressed text tile color="grey" @click="closeModal">
        <v-icon left>mdi-close</v-icon>
        Відмінити
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {ALERT_SHOW} from "@/store/actions/alert";
import {QUESTION_SHOW} from "@/store/actions/question";
import {
  SELECT_SERVICES,
  SELECT_SERVICES_ONE_TIME,
  SELECT_SERVICES_WITH_COUNTER,
  SELECT_SERVICES_WITHOUT_ALL_SERVICE
} from "@/store/actions/services";
import oneTimeChargeAPI from "@/utils/axios/one_time_charge"

import ModalComponentMixin from "@/mixins/modal_component";
import {START_MODAL_LOADING, STOP_MODAL_LOADING} from "@/store/actions/loading";
import {buildingTypes_select} from '@/utils/icons'

const modalDeleteId = 'one_time_charge_modal_delete'

export default {
  name: "HWP_One_Time_Charge",
  mixins: [ModalComponentMixin],
  components: {
    AddressElementSelect: () => import('@/components/autocomplite/AddressElementSelect'),
    AC_FlatIndicatorType: () => import("@/components/autocomplite/AC_FlatIndicatorType"),
    AC_TariffGroup: () => import("@/components/autocomplite/AC_TariffGroup"),
  },
  data() {
    return {
      new_service_name: '',
      service_dialog: false,
      navigation: false,
      all_flats: this.item.all_flats || false,
      city_id: this.item.city_id || null,
      streets: this.item.streets || [],
      buildings: this.item.buildings || [],
      divide_method: this.item.divide_method || null,
      calculate_method: this.item.calculate_method || null,
      indicator_id: this.item.indicator_id || null,
      service_id: this.item.service_id || null,
      counter_service_id: this.item.counter_service_id || null,
      flats_with_this_service: this.item.flats_with_this_service || null,
      comment: this.item.comment || '',
      tariff: this.item.tariff || 0,
      volume: this.item.volumes || null,
      month: this.item.month || null,
      tariff_group_type_id: this.item.tariff_group_type_id || null,
      building_type: this.item.building_type || null,
      flat_type: this.item.flat_type || 'all',
      filter_by_counter: this.item.filter_by_counter || null,
      filter_by_counter_select: [
        { text: 'Без відбору', value: 'without_counter_filter' },
        { text: 'З лічильниками', value: 'with_counter' },
        { text: 'З лічильниками (не подані покази)', value: 'with_counter_no_reading' },
        { text: 'З лічильниками (подані покази)', value: 'with_counter_reading' },
        { text: 'Без лічильників', value: 'without_counters' },
      ],
      divideMethodSelect: [
        { text: 'Розподіл об’єму * тариф', value: 'divide_volume_tariff' },
        { text: 'Розподіл суми ', value: 'divide_sum' },
        { text: 'Помножити норматив.показ на тариф', value: 'multiply_normative_tariff' },
        { text: 'Вказаний об’єм * тариф', value: 'multiply_volume_by_tariff' },
        { text: 'Фіксоване значення', value: 'fixed_value' },
      ],
      calculateMethodsSelect: [
        { value: 'by_square', text: 'по нормат.показнику', divide: ['divide_volume_tariff', 'multiply_normative_tariff', 'divide_sum'] },
        { value: 'by_fixed', text: 'фіксована сума', divide: ['fixed_value'] },
        { value: 'by_fixed', text: 'фіксована сума', divide: ['multiply_volume_by_tariff'] },
        { value: 'by_counter', text: 'по показниках', divide: ['divide_volume_tariff'] }
      ],
      buildingTypesSelect: buildingTypes_select,
      flatTypesSelect: [
        { text: 'Усі', value: 'all' },
        { text: 'Житлові', value: 'living' },
        { text: 'Нежитлові', value: 'not_living' },
      ]
    }
  },
  computed: {
    ...mapGetters({
      services: 'getServicesSelectOneTime',
      services_: 'getServicesSelectWithoutAll',
      current_month: 'getCurrentMonth',
    }),
    calculateMethodsSelectFiltered() {
      if (!this.divide_method) return []
      return this.calculateMethodsSelect.filter(i => i.divide.includes(this.divide_method))
    },
    savable() {
      if (!this.month) {
        return false
      }
      return this.current_month === this.month;

    }
  },
  methods: {
    ...mapActions({
      fetchServices: SELECT_SERVICES_ONE_TIME,
      fetchServices_: SELECT_SERVICES_WITHOUT_ALL_SERVICE,
    }),
    documentReady() {
      if (!this.all_flats) {
        if (!this.streets.length && !this.city_id && !this.buildings.length) {
          return false
        }
      }
      return true
    },
    createOneTimeService() {
      if (!this.new_service_name) {
        this.$store.commit(ALERT_SHOW, { text: 'Вкажіть назву послуги.', color: 'error' })
        return null
      }

      oneTimeChargeAPI.create_service(this.new_service_name)
        .then(response => response.data)
        .then(data => {
          this.fetchServices()
            .then(() => {
              this.$store.dispatch(SELECT_SERVICES)
              this.$store.dispatch(SELECT_SERVICES_WITH_COUNTER)
              this.$store.dispatch(SELECT_SERVICES_WITHOUT_ALL_SERVICE)
              this.$store.dispatch(SELECT_SERVICES_ONE_TIME)

              const service = this.services.find(item => item.value === data.value)
              if (service) {
                this.service_id = service.value
              }
              this.service_dialog = false
            })
        })
        .catch(err => {
          const error = err.response.data.detail;
          this.$store.commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
        })
      this.fetchServices_()
    },
    openServiceDialog() {
      this.service_dialog = true
      this.new_service_name = ''
    },
    flatIndicatorTypeChange(payload) {
      this.indicator_id = payload?.value || null
    },
    closeModal() {
      this.$emit('closeModal')
      this.itemId = this.item.id
      this.new_service_name = ''
      this.service_dialog = false
      this.all_flats = this.item.all_flats || false
      this.city_id = this.item.city_id || null
      this.streets = this.item.streets || []
      this.buildings = this.item.buildings || []
      this.calculate_method = this.item.calculate_method || null
      this.indicator_id = this.item.indicator_id || null
      this.service_id = this.item.service_id || null
      this.tariff_group_type_id = this.item.tariff_group_type_id || null
      this.comment = this.item.comment || ''
      this.tariff = this.item.tariff || 0
      this.month = this.item.month || null
      this.counter_service_id = this.item.counter_service_id || null
      this.divide_method = this.item.divide_method || null
      this.volume = this.item.volume || null
      this.flats_with_this_service = this.item.flats_with_this_service || null
      this.filter_by_counter = this.item.filter_by_counter || null
      this.building_type = this.item.building_type || null
      this.flat_type = this.item.flat_type || 'all'

      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
    autocompleteChange(payload) {
      this.tariff_group_type_id = payload.value || null
    },
    deleteDialog() {
      this.menu = false
      const payload = {
        text: `Підтвердіть вилучення разового нарахування: ${this.tariff}`,
        accept_button: true,
        id: modalDeleteId
      }
      this.$store.dispatch(QUESTION_SHOW, payload)
    },
    createFlatIndicator() {
      this.formValid = this.$refs.form.validate()
      if (!this.formValid) {
        this.formValid = false

        let text = ''

        if (this.calculate_method === 'by_square') {
          text = 'Вид розрахунку, послуга, вид показника та сума/тариф - мають бути заповнені'
        }
        if (this.calculate_method === 'by_fixed') {
          if (this.divide_method === 'multiply_volume_by_tariff') {
            text = 'Вид розрахунку, послуга, послуга (показників), відбір по наявності ліч., об’єм та сума/тариф - мають бути заповнені'
          } else {
            text = 'Вид розрахунку, послуга та сума/тариф - мають бути заповнені'
          }
        }
        if (this.calculate_method === 'by_counter') {
          text = 'Вид розрахунку, послуга, послуга (показників) та сума/тариф - мають бути заповнені'
        }

        this.$store.commit(ALERT_SHOW, {
          text: text,
          color: 'error lighten-1'
        })
        return
      }

      if (!this.documentReady()) {
        this.$store.commit(ALERT_SHOW, {
          text: 'Оберіть "усі квартири" або оберіть необхідні Вам параметри відбору (вулиці, будинки)',
          color: 'error lighten-1'
        })
        return;
      }

      const payload = {
        all_flats: this.all_flats,
        city_id: this.city_id ? this.city_id : null,
        streets: this.streets ? this.streets : [],
        buildings: this.buildings ? this.buildings : [],
        divide_method: this.divide_method,
        calculate_method: this.calculate_method,
        indicator_id: this.indicator_id ? this.indicator_id : null,
        service_id: this.service_id,
        comment: this.comment ? this.comment : null,
        tariff: this.tariff,
        volume: this.volume,
        month: this.current_month,
        counter_service_id: this.counter_service_id,
        flats_with_this_service: this.flats_with_this_service,
        tariff_group_type_id: this.tariff_group_type_id,
        filter_by_counter: this.filter_by_counter,
        building_type: this.building_type || null,
        flat_type: this.flat_type || 'all'
      }

      this.$store.commit(START_MODAL_LOADING)

      if (this.isNew) {
        oneTimeChargeAPI.create(payload)
          .then(response => response.data)
          .then(data => {
            if (data) {
              this.$emit('crud', Object.assign({}, data, {method: 'create'}))
              this.closeModal()
            }
          })
          .catch(err => {
            const error = err.response.data.detail;
            this.$store.commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
          })
          .finally(() => {
            this.$store.commit(STOP_MODAL_LOADING)
          })
      } else {
        payload['id'] = this.itemId
        oneTimeChargeAPI.update(payload)
          .then(response => response.data)
          .then(data => {
            if (data) {
              this.$emit('crud', Object.assign({}, data, {method: 'update'}))
              this.closeModal()
            }
          })
          .catch(err => {
            const error = err.response.data.detail;
            this.$store.commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
          })
          .finally(() => {
            this.$store.commit(STOP_MODAL_LOADING)
          })
      }

    },
    watch_item() {
      this.watcher = this.$watch(
          'item',
          {
            deep: true,
            immediate: true,
            handler(payload) {
              this.itemId = payload.id
              this.new_service_name = ''
              this.service_dialog = false
              this.all_flats = payload.all_flats || false
              this.city_id = payload.city_id || null
              this.streets = payload.streets || []
              this.buildings = payload.buildings || []
              this.divide_method = payload.divide_method || null
              this.calculate_method = payload.calculate_method || null
              this.indicator_id = payload.indicator_id || null
              this.service_id = payload.service_id || null
              this.comment = payload.comment || ''
              this.tariff = payload.tariff || 0
              this.volume = payload.volume || null
              this.month = payload.month || null
              this.counter_service_id = payload.counter_service_id || null
              this.flats_with_this_service = payload.flats_with_this_service || null
              this.tariff_group_type_id = payload.tariff_group_type_id || null
              this.filter_by_counter = payload.filter_by_counter || null
              this.building_type = payload.building_type || null
              this.flat_type = payload.flat_type || 'all'

              if (this.isNew) {
                this.divide_method = 'fixed_value'
                this.calculate_method = 'by_fixed'
              }
            }
          }
      )
    },
    watch_modal_answer() {
      this.delete_watcher = this.$watch(
          'modalAnswer',
          {
            handler(payload) {
              if (payload.id === modalDeleteId) {
                if (payload.answer) {
                  oneTimeChargeAPI.remove(this.itemId)
                  .then(response => response.data)
                  .then(data => {
                    if (data) {
                      this.$emit('crud', Object.assign({id: this.itemId}, {method: 'delete'}))
                      this.closeModal()
                    }
                  })
                  .catch(err => {
                    const error = err.response.data.detail;
                    this.$store.commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                  })
                }
              }
            }
          }
      )
    },
    watch_dialog() {
      this.dialog_watcher = this.$watch(
          'dialog',
          {
            immediate: true,
            handler(payload) {
              if (payload) {
                this.watch_item()
                this.watch_modal_answer()
              } else {
                if (this.watcher) {
                  this.watcher()
                }
                if (this.delete_watcher) {
                  this.delete_watcher()
                }
              }
            }
          }
      )
    }
  },
  created() {
    this.fetchServices()
  }
}
</script>
